import { FaWifi } from 'react-icons/fa';
import { images } from '../constants';

const pricing = [
  {
    id: 1,
    image: images.plan1,
    icons: [<FaWifi />],
    title: 'BLU_SMALL',
    subtitle: 'Solo Internet',
    speed: '30',
    price: 13.90,
    features: [
      'Navigazione',
      'E-mail',
      'Social Media',
      'Nessun limite di dati',
    ],
  },
  {
    id: 2,
    image: images.plan2,
    icons: [<FaWifi />],
    title: 'BLU_MEDIUM',
    subtitle: 'Solo Internet',
    speed: '50',
    price: 15.90,
    features: [
      'Streaming',
      'Didattica a distanza',
      'Utilizzo multimediale',
      'Nessun limite di dati',
    ],
  },
  {
    id: 3,
    image: images.plan3,
    icons: [<FaWifi />],
    title: 'BLU_PREMIUM',
    subtitle: 'Solo Internet',
    speed: '100',
    price: 19.90,
    features: [
      'Smart Worching',
      'Editing',
      'Upload frequenti',
      'Nessun limite di dati',
    ],
  },
];

export default pricing;